import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";
import AppHelmet from "../../components/AppComponents/AppHelmet";
import useFieldTypes from "../../api/api-hooks/cloud/useFieldTypes";
import BasicTableView from "./CloudListView/BasicTableView";

const GlobalCRMFieldTypesView = ({ urlStart }: { urlStart?: string }) => {
  const { fieldTypes, fieldTypesLoading } = useFieldTypes();
  urlStart = urlStart || "/supportal";

  return (
    <>
      <AppHelmet title="Field Types - GrowthCloud.com" />
      <div className="header pb-6">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col lg="auto" md="12">
                <h6 className="h2 mb-0">Field Types</h6>
                <Breadcrumb
                  className="d-none d-md-block mt-1"
                  listClassName="breadcrumb-links"
                >
                  <BreadcrumbItem>
                    <Link to={urlStart}>
                      <i className="mdi mdi-rocket" />
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Field Types</BreadcrumbItem>
                </Breadcrumb>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Container className="mt--6 pb-5" fluid>
        <hr className="mt-0 mb-4"></hr>
        <BasicTableView
          items={fieldTypes}
          loading={fieldTypesLoading}
          title="Field Types"
          getItemTitle={(f: any) => f.Name}
          getItemSubtitle={() => ""}
        />
      </Container>
    </>
  );
};

export default GlobalCRMFieldTypesView;
